import { Box, Paper, Stack, Typography } from '@mui/material';
import { PieValueType, useItemTooltip } from '@mui/x-charts-pro';

export type IncDonutChartShareTooltipProps = {
  data: PieValueType[];
  total: number;
};

/**
 * Custom pie tooltip: the hovered slice's label, its raw count, and its share
 * (as a percentage) stacked below the count. Used when IncDonutChart runs in
 * `showShare` mode.
 */
const IncDonutChartShareTooltip = ({
  data,
  total,
}: IncDonutChartShareTooltipProps) => {
  const item = useItemTooltip<'pie'>();
  if (!item) return null;

  const slice = data[item.identifier.dataIndex];
  if (!slice) return null;

  const share = total > 0 ? ((slice.value / total) * 100).toFixed(2) : '0.00';

  return (
    <Paper
      elevation={0}
      sx={{ p: 1.5, border: '1px solid', borderColor: 'divider' }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ marginBottom: 0.5 }}
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: item.color,
          }}
        />
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
          {slice.label as string}
        </Typography>
      </Stack>
      <Typography variant="body2">{slice.value.toLocaleString()}</Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {share}%
      </Typography>
    </Paper>
  );
};

export default IncDonutChartShareTooltip;
